export var InputVariantType;
(function (InputVariantType) {
    /**
     * @deprecated use REGULAR instead
     */
    InputVariantType["DEFAULT"] = "DEFAULT";
    InputVariantType["REGULAR"] = "REGULAR";
    InputVariantType["MAIN_SECTION"] = "MAIN_SECTION";
    InputVariantType["CONTACT_CENTER"] = "CONTACT_CENTER";
    InputVariantType["INPUT_PHONE"] = "INPUT_PHONE";
    InputVariantType["INPUT_DROPDOWN"] = "INPUT_DROPDOWN";
})(InputVariantType || (InputVariantType = {}));
//# sourceMappingURL=variants.js.map